import { useQuery } from '@tanstack/react-query';
import { reverseGeocode } from '@/lib/nominatim';
import type { GeoPoint } from '@/lib/geo';

/** Human-readable name of the selected location (OSM Nominatim). */
export function useReverseGeocode(location: GeoPoint) {
  const keyLat = location.lat.toFixed(3);
  const keyLon = location.lon.toFixed(3);
  return useQuery({
    queryKey: ['reverse-geocode', keyLat, keyLon],
    queryFn: ({ signal }) => reverseGeocode(location, signal),
    staleTime: Infinity,
    retry: 1,
  });
}
